export default {
    SET_INTERVALS_SETTINGS: 'setIntervalsSettings',
    SET_CURRENCY: 'setCurrency',
    SET_DATE: 'setDate',
    PUSH_TO_SELECTED: 'pushToSelected',
    SHIFT_FROM_SELECTED: 'shiftFromSelected',
    CLEAR_SELECTED: 'clearSelected',
}